export class Approval {
    id: number;
    bankId: number;
    sitCred: string;
    obs: string;
    file: string;
    quantity: number;
    initQuantity: number;
    endDate: string;
    approval: string;

    constructor(id: any, bankId: any, sitCred: any, obs: any, file: any, qtd: any, initQtd: any, endDate: any, approval: any){
        this.id = id;
        this.bankId = bankId;
        this.sitCred = sitCred;
        this.obs = obs;
        this.file = file;
        this.quantity = qtd;
        this.initQuantity = initQtd;
        this.endDate = endDate ? endDate : '';
        this.approval = approval ? approval : '';
    }
}
